import { render, staticRenderFns } from "./SalaryScale.vue?vue&type=template&id=0958287b&scoped=true&"
import script from "./SalaryScale.vue?vue&type=script&lang=js&"
export * from "./SalaryScale.vue?vue&type=script&lang=js&"
import style0 from "./SalaryScale.vue?vue&type=style&index=0&id=0958287b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958287b",
  null
  
)

export default component.exports